import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Box, Typography, Button, CircularProgress, Alert, Table, TableHead, TableRow, TableCell, TableBody, TablePagination } from '@mui/material';
import { api_url } from '../constants'; // Ensure the API URL is correct

const DeleteRequestList = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5); 

    useEffect(() => {
        fetchDeleteRequests();
    }, []);

    const fetchDeleteRequests = async () => {
        try {
            const response = await axios.get(`${api_url}/api/users/delete-account-requests`);
            setRequests(response.data);
            setLoading(false);
        } catch (err) {
            // setError('Failed to fetch delete requests.');
            setLoading(false);
        }
    };

    const handleDeleteRequest = async (id) => {
        try {
            const response = await axios.post(`${api_url}/api/users/delete-account-requests/${id}/accept`);
            if (response.status === 200) {
                setSuccessMsg('User deleted successfully.');
                fetchDeleteRequests(); // Refresh the request list
            }
        } catch (err) {
            setError('Failed to delete user.');
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to first page when rows per page changes
    };

    return (
        <div>
            {loading && <CircularProgress />}

            {error && <Alert severity="error">{error}</Alert>}
            {successMsg && <Alert severity="success">{successMsg}</Alert>}

            {/* Table for displaying requests */}
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Email</TableCell>
                        <TableCell>Phone Number</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {requests
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) // Paginate the requests
                        .map((request) => (
                            <TableRow key={request._id}>
                                <TableCell>{request.email}</TableCell>
                                <TableCell>{request.phoneNumber}</TableCell>
                                <TableCell>{request.status}</TableCell>
                                <TableCell>
                                    {request.status === 'pending' && (
                                        <Button
                                            variant="contained"
                                            color="error"
                                            onClick={() => handleDeleteRequest(request._id)}
                                        >
                                            Delete Account
                                        </Button>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>

            {/* Pagination */}
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={requests.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
    );
};

export default DeleteRequestList;
